goog.provide("shadow.js.shim.module$src$svg$artwork$table_svg$default");
shadow.js.shim.module$src$svg$artwork$table_svg$default = shadow.js.shim.module$src$svg$artwork$table_svg.default;
